import React from 'react'
import Tabs from './Tabs'

interface Props {
  children: (activeTab: number) => React.ReactNode
}

const SettingsTabs = ({ children }: Props) => {
  return (
    <Tabs
      tabs={[
        {
          label: 'user',
        },
        {
          label: 'company',
        },
      ]}
    >
      {(activeTab) => (
        <div className='bg-white flex flex-col gap-11 shadow-form max-w-6xl p-5 md:px-7 lg:p-12 rounded-tl-none rounded-20px'>
          {children(activeTab)}
        </div>
      )}
    </Tabs>
  )
}

export default SettingsTabs
